
<template>
  <div>
    <section class="lms-container">
       <view-alert v-if="showAlert" @close="showAlert=false;" @markedRead="getAlerts()" :alertList="alertList" />
      <div class="content">
        <div class="title-section-content">
          <h3 v-if="userType == 0">Minhas especializações</h3>
          <h3 v-if="userType != 0">Meus Cursos</h3>
        </div>

        <!-- <s:if test="classes == null || classes.isEmpty()">
					<div class="placeholder-message">
						<h5>Você não possui nenhuma especialização</h5>
					</div>
        </s:if>-->

        <ul class="courses-list">
          <div
            v-for="course in courses"
            :key="course.id"
            class="course-item"
            style="background-color: #1f4284;"
            v-bind:style="{ 'background-image': 'url(' + course.image_path + ') '}"
          >
            <div class="text-content">
              <!-- 
								<h3 class="online-course">
										<s:property value="course.name" />
								</h3> 
              -->

              <ul style="display:inline-block;list-style-type:none;justify-content: center;">
                <li></li>
                <li style="float:none;display: list-item;">
                  <a style="width:100%;" v-on:click="showModules(course)" href="#">Acessar curso</a>
                </li>
                <li style="float:none;display: list-item;" v-if="course.certificateAvailable">
                  <a
                    style="width:100%;"
                    href="#"
                    v-on:click="generateCertificate(course)"
                  >Gerar Certificado</a>
                </li>
              </ul>
            </div>
          </div>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import Alert from "./Alert.vue";
import router from "../../router";
import ViewAlert from "./Alert/ViewAlert";

axios.defaults.withCredentials = true;

export default {
  data() {
    return {
      courses: [],
      message: "",
      showMessage: false,
      userType: null,
      alertList: [],
      showAlert: false
    };
  },
  components: {
    alert: Alert,
    ViewAlert: ViewAlert
  },
  computed: {},
  methods: {
    showModules(course) {
      this.$store.commit("change_course", course);
      router.push("/home/classes");
    },
    getCourses() {
      const path = this.$global.endpoint + "/course/getall";
      axios
        .get(path)
        .then(res => {
          this.courses = res.data;
          console.log(this.courses);
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    getAlerts() {
      const path = this.$global.endpoint + "/user/message/getallunread";
      axios
        .post(path, {})
        .then(res => {
          this.alertList = res.data.messages;
          console.log("aqui", this.alertList);
          if (this.alertList.length > 0){
            this.showAlert = true;
          }

          console.log(this.alertList);
        })
        .catch(error => {
          console.error(error);
        });
    },
    generateCertificate(course) {
      console.log(course.id);
      let apiCall = "/courseCertificate/generateCertificate";
      const path = this.$global.endpoint + apiCall;

      axios({
        url: path,
        data: {
          courseId: course.id
        },
        method: "POST",
        responseType: "blob" // important
      })
        .then(res => {
          var blob = new Blob([res.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Report.pdf";
          link.click();
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getCourses();
    this.userType = this.$store.getters.user.type;
    this.getAlerts();
  }
};
</script>
